$(document).ready(function() {
  $(document).on('ajax:success', '.message-widget', (event) => {
    const [_data, _status, xhr] = event.originalEvent.detail;
    $(event.target).siblings('.message-thread').first().append(_data);
    $(event.target).find('textarea').val('');
  })
});